import type { AppResponsiveBrkPt } from '../../css-variables'
import { useResponsiveMatches } from './useResponsiveMatches'

export const useIsScreenSize = (size: AppResponsiveBrkPt) => useResponsiveMatches()[size]
export const useIsScreenSizeMobile = () => !useIsScreenSize('md')
